import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

export const ToastHandler = () => {
  const location = useLocation<{ toast?: { title: string; options?: any } }>()
  const message = location?.state?.toast

  useEffect(() => {
    if (!message) {
      return
    }

    toast(message.title, message.options)

    // Clear state after showing toast
    window.history.replaceState({}, document.title)
  }, [message])

  return null
}
